import { useState, useEffect, useCallback, useRef } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

export const useDashboardMetrics = (idUsuarioAsignado = null) => {
  const [metrics, setMetrics] = useState({
    iTotalHoy: 0,
    iTotalAyer: 0,
    iPendientes: 0,
    iEnProgreso: 0,
    iResueltosHoy: 0,
    iTotalHistorico: 0,
    iTotalResueltos: 0,
    iTiempoRespuestaPromedio: 0,
    iTiempoCierrePromedio: 0,
    iTiempoRespuestaPromedioHoy: 0,
    iTiempoCierrePromedioHoy: 0,
    iMaxCurrentTicket: 0
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useToken();
  const { showErrorToast } = useToast();
  const isFetchingRef = useRef(false);

  // Consulta exclusiva de las tarjetas KPI del Dashboard
  const fetchMetrics = useCallback(async () => {
    if (!token || isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsLoading(true);
    setError(null);

    try {
      const hasAgent = idUsuarioAsignado && idUsuarioAsignado !== 'todos' && idUsuarioAsignado !== 'all';
      const queryParam = hasAgent ? `?idUsuarioAsignado=${idUsuarioAsignado}` : '';
      const metricsUrl = `/api/SupportEngine/GetDashboardMetrics${queryParam}`;

      const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      };

      const resp = await fetch(metricsUrl, { headers });
      if (resp.ok) {
        const json = await resp.json();
        const rawMetrics = json.data || json || {};

        setMetrics({
          iTotalHoy: rawMetrics.iTotalHoy ?? rawMetrics.totalHoy ?? 0,
          iTotalAyer: rawMetrics.iTotalAyer ?? rawMetrics.totalAyer ?? 0,
          iPendientes: rawMetrics.iPendientes ?? rawMetrics.pendientes ?? 0,
          iEnProgreso: rawMetrics.iEnProgreso ?? rawMetrics.enProgreso ?? 0,
          iResueltosHoy: rawMetrics.iResueltosHoy ?? rawMetrics.resueltosHoy ?? 0,
          iTotalHistorico: rawMetrics.iTotalHistorico ?? rawMetrics.totalHistorico ?? 0,
          iTotalResueltos: rawMetrics.iTotalResueltos ?? rawMetrics.totalResueltos ?? 0,
          iTiempoRespuestaPromedio: rawMetrics.iTiempoRespuestaPromedio ?? rawMetrics.iTiempoRespuestaPromedioMinutos ?? 0,
          iTiempoCierrePromedio: rawMetrics.iTiempoCierrePromedio ?? rawMetrics.iTiempoResolucionPromedioMinutos ?? 0,
          iTiempoRespuestaPromedioHoy: rawMetrics.iTiempoRespuestaPromedioHoy ?? 0,
          iTiempoCierrePromedioHoy: rawMetrics.iTiempoCierrePromedioHoy ?? 0,
          iMaxCurrentTicket: rawMetrics.iMaxCurrentTicket ?? rawMetrics.maxCurrentTicket ?? 0
        });
      }
    } catch (err) {
      setError(err.message);
      if (showErrorToast) {
        showErrorToast(err.message || 'Error al cargar métricas');
      }
    } finally {
      isFetchingRef.current = false;
      setIsLoading(false);
    }
  }, [token, idUsuarioAsignado, showErrorToast]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return {
    metrics,
    isLoading,
    error,
    reloadMetrics: fetchMetrics
  };
};
